import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportServicoProdutoUseCase } from "../../../presentation/useCases/read/get_report_servico_produto_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportServicoProdutoUseCase
 */

export class GetReportServicoProdutoUseCase implements IGetReportServicoProdutoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportServicoProduto(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportServicoProduto(requiredMimeType);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `produtos_servicos_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
